import React from 'react'
import { Typography, Icon, Row, Col, Button } from 'antd'
import { Queries } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import pdfMock from '../../../assets/images/course/หลักสูตร.pdf'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { convertToHTMl } from '../../../utils/markDown'
import { changeFormatdate, changeFormatdateStartEnd } from '../../../utils/formatdate'
import IframeFile from '../../../components/user/IframeFile'
import ImageFile from '../../../components/user/ImageFile'

const { Text, Title } = Typography

class CourseDetail extends React.Component {

    state = {
        detailData: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        srcLink:null,
        urlLink: null
    }

    fetchCourse = async () => {
        const { client, location, match } = this.props
        const { selectMonth, selectYear } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchNotification,
            variables: {
                notificationId: match.url.split('/')[3]
            }
        })

        //////////////////////addmodalINTERNAL_SERVER_ERROR
        // if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
        //     await this.setState({
        //         showModalErrors: true
        //     })
        // }

        await this.setState({
            detailData: data.fetchNotification,
        })

        console.log(data)
        let urlLink = null

        if(data.fetchNotification.notiFrom == 'CONICLE'){
            let redirectPath = data.fetchNotification.redirectPath
            let dataNoti = await client.query({
                query: Queries.fetchUrlConicleRedirectPath,
                variables: {
                    redirectPath
                }
            })

            urlLink = dataNoti.data.fetchUrlConicleRedirectPath.url
        }else{
            urlLink = data.fetchNotification.redirectPath
        }

        await this.setState({
            urlLink
        })

    }

    base64ToBlob = (base64, type = "application/octet-stream" ) => {
		const binStr = atob( base64 );
		const len = binStr.length;
		const arr = new Uint8Array(len);
		for (let i = 0; i < len; i++) {
		  arr[ i ] = binStr.charCodeAt( i );
		}
		return new Blob( [ arr ], { type: type } );
	}

    async componentDidMount() {
        await this.fetchCourse()
    }

    render() {
        const { match } = this.props
        const { detailData, srcLink, urlLink } = this.state
        // console.log(this.state.detailData.linkFile)
        // console.log(detailData.length !== 0 ? detailData.fileData.fileMimeType : 'ss')
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {detailData.length !== 0  &&
                    <Row justify="center" gutter={24}>
                        <Col span={16} offset={4}>
                            {/* <div className="mb-4">
                                <ImageFile typeFile={detailData.fileData.fileMimeType}  file={detailData.fileData.fileId}/>
                            </div> */}
                            <Title level={4} className="mr-2 mb-3" style={{ display: "inline-block" }}>
                                {detailData.title}
                            </Title>
                            
                            <div className='mb-3'>
                                <Text>
                                    { detailData.body ? <div dangerouslySetInnerHTML={{ __html: convertToHTMl(detailData.body) }}/> : '' }
                                </Text>
                            </div>
                                
                            {
                                urlLink &&
                                <div className="mt-5">
                                    <p>รายละเอียดเพิ่มเติม  <a href={urlLink} style={{ textDecoration:"underline" }} target="_blank">คลิกที่นี่</a></p>
                                </div>
                            }

                            <div className="my-3">
                                <Row>
                                    <Col xs={23} md={23} className="word-wrap">
                                        <div className="mt-2">
                                            <Text className="font-italic" style={{ color: '#FEB12A' }}>
                                                <span className="ml-1">วันที่ {changeFormatdateStartEnd(detailData.createdAt)} </span>
                                                {/* {
                                                    detailData.endDate &&
                                                    <>
                                                     - วันที่ {changeFormatdateStartEnd(detailData.endDate)}
                                                    </>
                                                } */}
                                            </Text>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                }
            </Container>
        )
    }
}

CourseDetail.propTypes = {
    //
}

export default withApollo(CourseDetail)